import { render, staticRenderFns } from "./residingGuest.vue?vue&type=template&id=6d305745&scoped=true&"
import script from "./residingGuest.vue?vue&type=script&lang=js&"
export * from "./residingGuest.vue?vue&type=script&lang=js&"
import style0 from "./residingGuest.vue?vue&type=style&index=0&id=6d305745&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d305745",
  null
  
)

export default component.exports